export default function BrandIntro() {
  return (
    <section className="py-10 md:py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-6">
          关于我们
        </h1>
        <div className="flex flex-col gap-4 text-sm md:text-base text-foreground-700 leading-relaxed">
          <p>
            "安全指南"是一个致力于提供网络信息安全与合规知识的教育平台。我们的团队由信息安全专家、法律顾问和数字素养教育者组成，旨在帮助成年用户建立科学的网络使用观念，掌握必要的安全防护技能。
          </p>
          <p>
            我们坚信，知识是最好的防护武器。在一个信息日益复杂的数字世界中，每个人都有权获得准确、客观、实用的安全知识。我们的内容坚持以事实为依据、以法律为准绳，力求在专业性和可读性之间找到最佳平衡。
          </p>
          <p>
            自平台成立以来，我们已发布数十篇深度文章，涵盖合规平台识别、隐私保护、安全访问技巧、法律风险提示、防诈骗指南及病毒防护六大主题领域，帮助数以万计的用户提升了网络安全素养。我们将继续在这个领域深耕，为构建更加安全、理性的网络环境贡献力量。
          </p>
        </div>
      </div>
    </section>
  );
}